import { TeamContext } from "@/contexts/TeamContext";
import { useContext } from 'react';

export const useTeams = () => {
  const context = useContext(TeamContext);
  if (context === undefined) {
    throw new Error('useTeams must be used within an TeamProvider');
  }
  return context;
};